import styled from 'styled-components';

export const Container = styled.div`
	position: relative;
	margin-right: 0.4rem;
`;
